export const SHIPMENTS_API = '/shipments';
export const BOXES_API = '/boxes';
export const FILES_API = '/files';

export const STORAGE_SECTION = 1;

export const TYPE_FBA = 'fba';
export const TYPE_FBM = 'fbm';

export const STATUS_IN_PROCESS = 'inprocess';
export const STATUS_READY = 'ready';
export const STATUS_PROCESSING = 'processing';
export const STATUS_SHIPPED = 'shipped';

export const STATUS_INIT = 0;
export const STATUS_LOADING = 1;
export const STATUS_OK = 2;
export const STATUS_FAIL = 3;
